import Img1 from "public/iaas/costEfficient.4c199bb4.svg";
import Img2 from "public/iaas/wordpress-service.2952b864.svg";
import Img3 from "public/iaas/containerizedHosting.0e1aa36b.svg";

export const USECASES_CONSTANTS = {
  title: "Use Cases for IaaS",
  list: [
    {
      image: Img1,
      title: "Startups & SMEs",
      content: "Deploy applications quickly without investing in hardware.",
    },
    {
      image: Img2,
      title: "E-Commerce Platforms",
      content: "Handle fluctuating traffic during high-demand sales.",
    },
    {
      image: Img3,
      title: "Development & Testing",
      content: "Build and test environments without interfering with production.",
    },
    {
      image: Img2,
      title: "Financial & Healthcare",
      content: "Secure, compliant infrastructure for sensitive data.",
    },
    {
      image: Img1,
      title: "AI, ML & Big Data Analytics",
      content: "GPU-powered IaaS for intensive computing.",
    },
  ],
};
